import React from 'react';
import { Link, NavLink, Outlet } from 'react-router-dom';
import '../../styles/design-preview.css';

const NAV = [
  { to: '/design-preview', label: 'Overview', end: true },
  { to: '/design-preview/import-review', label: 'Import review' },
  { to: '/design-preview/import-complete', label: 'Import complete' },
  { to: '/design-preview/route-plan', label: 'Route plan' },
];

const DesignPreviewLayout = () => (
  <div className="design-preview">
    <div className="dp-banner">
      <span className="dp-banner__badge">Preview</span>
      <span>
        Polished UI concepts — not wired to production. Current app unchanged at{' '}
        <code>/freight/import</code> and <code>/route-planner</code>.
      </span>
      <Link to="/freight" className="dp-banner__link">
        Back to live app
      </Link>
    </div>

    <div className="dp-shell">
      <aside className="dp-sidebar">
        <div className="dp-brand">
          <div className="dp-brand__mark">B</div>
          <div>
            <div className="dp-brand__name">Boxed</div>
            <div className="dp-brand__sub">Provision Global</div>
          </div>
        </div>
        <nav className="dp-nav">
          <div className="dp-nav__section">Design previews</div>
          {NAV.map((item) => (
            <NavLink
              key={item.to}
              to={item.to}
              end={item.end}
              className={({ isActive }) =>
                `dp-nav__link${isActive ? ' dp-nav__link--active' : ''}`
              }
            >
              {item.label}
            </NavLink>
          ))}
        </nav>
        <div className="dp-nav__section dp-nav__section--muted">Live modules</div>
        <Link to="/freight/import" className="dp-nav__link dp-nav__link--ghost">
          Import PDF (current)
        </Link>
        <Link to="/route-planner" className="dp-nav__link dp-nav__link--ghost">
          Route planner (current)
        </Link>
      </aside>

      <main className="dp-main">
        <Outlet />
      </main>
    </div>
  </div>
);

export default DesignPreviewLayout;
